/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum ServiceRideOrderStatus {
    "RideOrderStatusProcessing" = "processing",
    "RideOrderStatusDone" = "done",
    "RideOrderStatusDriverAccepted" = "driver_accepted",
    "RideOrderStatusCanceled" = "canceled"
}